import type { Vod, VodUpdateObj } from '@setplex/tria-api'
import type { Event } from 'effector'

import { api } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'
import { not } from 'patronum'

export interface ICWatching {
  content: Vod
  stoppedTime: number
  lengthMillis: number
}

export const updateVod = createEvent<VodUpdateObj>()

export const updateTime = createEvent<ICWatching>()

const updateTimeFormat: Event<{
  vodId: number
  stoppedTime: number
  lengthMillis: number
}> = updateTime.map(({ content: { id }, stoppedTime, lengthMillis }) => ({
  vodId: Number(id),
  stoppedTime,
  lengthMillis,
}))

export const removeTime = createEvent<{ vod: Vod }>()

const removeTimeFormat: Event<{ vodId: number }> = removeTime.map(
  ({ vod: { id } }) => ({
    vodId: Number(id),
  })
)

sample({
  clock: updateTimeFormat,
  filter: not(api.vods.updateVodFx.pending),
  target: api.vods.updateContinueWatchingFx,
})

sample({
  clock: removeTimeFormat,
  target: api.vods.removeContinueWatchingFx,
})

sample({
  clock: updateVod,
  target: api.vods.updateVodFx,
})
